import notifications from '~/vue/plugins/notifications';
import globalEventBus, {GLOBAL_EVENTS} from 'shared/globalEventBus';
import WsNewAlertNotification from '../../angular/app/ws_messages/WsNewAlertNotification.vue';

let audio = new Audio('/static/audio/message_sound.mp3');

function playNotification() {
    audio.load();
    try {
        audio.play(); // ios no interaction error message possible.
    } catch (e) {
    }
}

export const onNewRequestAlert = async (e) => {
    /**
     * @param {LiveEventNewRequestAlert} e
     */
    notifications.Notification({
        delay: 8000,
        title: 'New Alert',
        component: WsNewAlertNotification
    });
    globalEventBus.emit(GLOBAL_EVENTS.UPDATE_TASKS_COUNTERS);
    playNotification();
};
